import { render, staticRenderFns } from "./DetailSupply.vue?vue&type=template&id=5ad20fc9&scoped=true"
import script from "./DetailSupply.vue?vue&type=script&lang=ts"
export * from "./DetailSupply.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad20fc9",
  null
  
)

export default component.exports